import { render } from "./AddLeadForm.vue?vue&type=template&id=1a926244"
import script from "./AddLeadForm.vue?vue&type=script&lang=js"
export * from "./AddLeadForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__